import {
    UPDATE_COST_CENTER_RESPONSE,
    SET_FLEET_PO,
    ISVEHICLECONSOLIDATEDCHECKED,
    ISMANAGEEQUIPCONSOLIDATEDCHECKED,
    ISNONSTANDARDCONSOLIDATEDCHECKED,
    SET_DISPOSITION_DATA,
    SET_TRANSFER_DATA,
    IS_SAVE_PURCHASE_ORDER_LOADING,
    SET_INITIAL_DISPOSITION_DATA,
    SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS,
    CREATE_CONSOLIDATED_PO_RESPONSE
} from "./FleetProcessingType";

const initialState = {
    isCostCenterUpdated:[],
    fleetPo:{},
    isVehicleConsolidatedChecked:"",
    isManageEquipConsolidatedChecked:"",
    isNonstandardConsolidatedChecked:""
  };

const reducer = (state = initialState, action: any) => {
    switch (action.type) {  
        case UPDATE_COST_CENTER_RESPONSE:
            return {
                ...state,
                isCostCenterUpdated: action.isCostCenterUpdated,
            }; 
        case SET_FLEET_PO:
            return {
              ...state,
              fleetPo: action.payload,
            };  
        case ISVEHICLECONSOLIDATEDCHECKED:
            return {
                ...state,
                isVehicleConsolidatedChecked: action.isChecked,
            };  
        case ISMANAGEEQUIPCONSOLIDATEDCHECKED:
            return {
                ...state,
                isManageEquipConsolidatedChecked: action.isChecked,
            };  
        case ISNONSTANDARDCONSOLIDATEDCHECKED:
            return {
                ...state,
                isNonstandardConsolidatedChecked: action.isChecked,
            }; 
        case IS_SAVE_PURCHASE_ORDER_LOADING:
            return {
                ...state,
                isSavePurchaseOrderLoading: action.isLoading,
            };
        case SET_DISPOSITION_DATA:
            return {
                ...state,
                dispositionData: action.dispositionData,
            };
        case SET_TRANSFER_DATA:
            return {
                ...state,
                transferData: action.transferData,
            };
        case SET_INITIAL_DISPOSITION_DATA:
            return {
                ...state,
                initialDispositionData: action.initialDispositionData,
            };
        case SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS:
            return {
                ...state,
                validateAndSaveMultiplePoSuccess: action.validateAndSaveMultiplePoSuccess,
            };
        case CREATE_CONSOLIDATED_PO_RESPONSE:
            return {
                ...state,
                consolidatedFleetPo: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
